export default "__VITE_ASSET__rp2BtlC9__"